export default function Services() {
  const services = [
    { label: 'Minha carga', icon: '📦', href: 'https://wa.me/11946384844?text=Quero+ver+minha+carga' },
    { label: 'Nova entrega', icon: '🚚', href: 'https://wa.me/11946384844?text=Quero+fazer+uma+nova+entrega' },
    { label: 'Perfil', icon: '👤', href: 'https://wa.me/11946384844?text=Quero+acessar+meu+perfil' },
    { label: 'Veículos disponíveis', icon: '🚐', href: 'https://wa.me/11946384844?text=Quais+veículos+estão+disponíveis' },
    { label: 'Rastreamento', icon: '📍', href: 'https://wa.me/11946384844?text=Quero+rastrear+minha+entrega' },
    { label: 'Central de dúvidas', icon: '💬', href: 'https://wa.me/11946384844?text=Tenho+uma+dúvida' },
    { label: 'Meus Contratos', icon: '📋', href: 'https://wa.me/11946384844?text=Quero+ver+meus+contratos' },
    { label: 'Cotação', icon: '💰', href: 'https://wa.me/11946384844?text=Quero+fazer+uma+cotação', highlight: true },
  ];

  return (
    <section id="transporte" className="bg-brand-light py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-5">

        <div className="text-center mb-14">
          <span className="reveal inline-block text-xs tracking-[0.2em] uppercase text-brand-gold font-body font-semibold mb-3">
            Portal do cliente
          </span>
          <h2 className="reveal font-display font-black text-4xl md:text-5xl text-brand-dark" data-delay="100">
            Transportes
          </h2>
          <p className="reveal font-body text-gray-500 mt-3 max-w-md mx-auto text-sm" data-delay="200">
            Acesse todos os serviços disponíveis diretamente pelo WhatsApp.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {services.map((s, i) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`reveal card-lift flex flex-col items-center justify-center gap-2 px-4 py-6 rounded-sm border text-center transition-all duration-300
                ${s.highlight
                  ? 'bg-brand-green border-brand-green text-white hover:bg-brand-dark hover:border-brand-dark'
                  : 'bg-white border-gray-200 text-brand-dark hover:border-brand-green hover:text-brand-green'
                }`}
              data-delay={i * 60}
            >
              <span className="text-2xl leading-none">{s.icon}</span>
              <span className="font-body font-medium text-sm">{s.label}</span>
            </a>
          ))}
        </div>

        {/* WhatsApp CTA */}
        <div className="reveal mt-12 text-center" data-delay="400">
          <a
            href="https://wa.me/11946384844"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe5b] text-white font-body font-semibold px-8 py-4 rounded-sm transition-colors duration-300 text-sm shadow-lg shadow-green-200"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
            </svg>
            Falar via WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
